<style lang="less" scoped>
.btn-container{
    position:fixed;
    width:670px;
    margin:0 auto;
    height:100px;
    line-height: 100px;
    text-align: center;
    font-size: 36px;
    color:#FF6AB7;
    bottom:30px;
    background:#333;
    left:40px;
    border-radius: 100px;;
 }
 .wrapper{
    background:linear-gradient(180deg, #5febf3 0% ,  #fff 50%);
    padding:50px 30px;
 }
 .title{
    display: flex;
    justify-content: start;
    align-items: center;
    img{
        width:100px;
        height:100px;
        margin-right: 20px;        
    }
    .title-text{
        font-size: 40px;
    }    
 }
 .img-container{
        width:670px;
        margin-top: 100px;
        img {
            width: 100%;
        }
    }
    .placholder{
        height:130px;
    }
</style>
<template>
    <div class="wrapper">
        <h1 class="title">
            <img src="../../assets/images/logo.png" alt="">
            <p class="title-text">BenevoLend</p>
        </h1>
        <div class="img-container">
            <img src="../../assets/images/promotion/repay.png" alt="">
        </div>
        <div class="btn-container" @click="jump">Repayment Now</div>
        <div class="placholder"></div>
    </div>
</template>
<script>
import { useLoading } from 'vue-loading-overlay'
import {useRouter} from 'vue-router'
export default {
    setup () {
        const loading = useLoading()
        const router = useRouter()
        const jump = () => {
            const loader = loading.show({
                container: null
            }) 
            window.location.href = "Https://bbposervices.com/awake"             
            setTimeout(()=>{
                console.log(123123)
                loader.hide()  
                router.replace({
                    "path":"/login"
                })
            },4000)

        }
        return {
            jump
        }
    }
    
}
</script>